import {
  CreateIdentityRequest,
  CreateWearableAssociationRequest,
  ShowTerminalRequest,
  TerminalRequestsApi,
} from '@trybeapp/sdk'
import { useMutation, useQuery, useQueryClient, UseQueryOptions } from 'react-query'
import { apiConfiguration } from 'utilities/TrybeApiClient'

const api = new TerminalRequestsApi(apiConfiguration)

export const useCreateAssociationRequest = () => {
  const queryClient = useQueryClient()

  return useMutation(
    (createWearableAssociationRequest: CreateWearableAssociationRequest) => {
      return api.createWearableAssociationRequest({ createWearableAssociationRequest })
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['terminalRequests'])
        queryClient.invalidateQueries(['listAssociatedBarcodes'])
      },
    }
  )
}

export const useTerminalRequest = (
  terminalRequestId: string,
  options?: UseQueryOptions<ShowTerminalRequest>
) => {
  return useQuery<ShowTerminalRequest>(
    ['terminalRequest', terminalRequestId],
    () => api.getTerminalRequest({ terminalRequestId }),
    {
      enabled: !!terminalRequestId,
      refetchInterval: 2000, // Poll every 2 seconds
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retry: false,
      ...options,
    }
  )
}

export const useCancelTerminalRequest = () => {
  const queryClient = useQueryClient()

  return useMutation(
    (terminalRequestId: string) => {
      return api.actionCancelTerminalRequest({ terminalRequestId })
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['terminalRequests'])
      },
    }
  )
}

export const useCreateIdentityRequest = () => {
  const queryClient = useQueryClient()

  return useMutation(
    (createIdentityRequest: CreateIdentityRequest) => {
      return api.createIdentityRequest({ createIdentityRequest })
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['terminalRequests'])
      },
    }
  )
}
